import { useContext } from 'react';
import { AxiosContext } from '../../providers/axiosContext';
import { ProfileDTO } from './dto';
export interface ProfileService {
  fetchProfile: () => Promise<ProfileDTO>;
}

export const useProfileService = (): ProfileService => {
  const axiosContext = useContext(AxiosContext);

  const fetchProfile = async () => {
    const res = await axiosContext.newAuthAxios.get('/api/auth/users/me');
    return res.data.data;
  };

  return {
    fetchProfile,
  };
};
